import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { CancelStatementDialogComponent } from 'src/app/modules/jaldee-subscription/subscription-statements/statements/statement-list/cancel-statement-dialog/cancel-statement-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageDisplayModule } from '../../validation-messages-display/message-display.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MessageDisplayModule,
    ],
    declarations: [
        CancelStatementDialogComponent
    ],
    exports: [
        CancelStatementDialogComponent
    ]
})
export class CancelStatementModule { }
